var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdfPreview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "10 147 734 762",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134.19 785.48h469.84c4.969 0 8.969-4.133 8.969-9.268v-443.68c0-40.444-108.27-135.6-145.85-135.6h-332.97c-4.969 0-8.969 4.134-8.969 9.268v570.01c0 5.134 4 9.268 8.969 9.268z",
    fill: "url(#j)",
    fillRule: "evenodd",
    stroke: "#888a85",
    strokeWidth: 16.031
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    opacity: 0.17,
    d: "M166.11 414.75h345.81v32.934H166.11zm0 63.15h329.21v32.934H166.11zm.45 65.98h296.02v32.934H166.56zm.35 68.47h345.81v32.934H166.91z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M485.26 197.16c27.831-5.093 131.44 69.939 127.26 131.2-21.428-37.411-65.226-19.866-121.55-22.321 0 0 5.42-101.16-5.718-108.88z",
    fill: "url(#k)",
    fillRule: "evenodd",
    stroke: "#868a84",
    strokeWidth: 14.548
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M505.15 231c18.776 10.558 60.699 33.14 78.51 62.182-21.878-10.5-40.406-3.235-78.163-2.94 0 0 2.225-47.277-.347-59.242z",
    fill: "none",
    opacity: 0.369,
    stroke: "url(#l)",
    strokeWidth: 14.548
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M291.05 610.15s35.798 31.854 66 83.703c37.342 64.105 43.319 140.57 41.845 139.25h54.825s2.556-138.56 64.764-237.05c62.208-98.483 198.07-243.76 198.07-243.76s-99.063 57.006-195.71 161.2c-87.533 94.369-100.28 172.98-100.28 172.98s-1.72-6.147-24.055-33.964c-26.014-32.4-102.85-61.378-105.46-42.368z",
    fill: "url(#i)",
    fillRule: "evenodd",
    stroke: "#4e9a06",
    strokeWidth: 13.524
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    opacity: 0.23,
    d: "M332.99 806.24h274.36v67.699H332.99z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M607.35 806.24v67.695c29.261.127 70.739-15.167 70.739-33.852 0-18.685-32.653-33.843-70.739-33.843z",
    fill: "url(#d)",
    opacity: 0.23
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M332.99 806.24v67.695c-29.261.127-70.739-15.167-70.739-33.852s32.653-33.843 70.739-33.843z",
    fill: "url(#e)",
    opacity: 0.23
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M631.34 428.4c-30.67 24.694-65.974 56.107-101.02 93.886-42.763 46.103-67.058 88.104-80.663 118.38-13.605 30.278-19.427 61.708-19.427 61.708-.989 5.947.185 17.332-5.832 17.689-6.018.357-14.555-24.234-16.241-30.021.069.185.493 1.318.265.867-.248-.489-.956-1.776-2.385-3.998-2.858-4.445-8.628-12.628-19.606-26.302-10.297-12.825-34.97-28.251-56.144-36.538-3.962-1.55-7.732-2.77-11.32-3.83 13.605 15.02 32.205 37.874 49.231 67.103 19.644 33.723 30.766 69.996 36.948 97.86 3.091 13.932 4.933 25.76 5.925 34.202.038.322.037.46.073.771h30.276c1.985-35.61 12.262-145.67 66.164-231.01 31.87-50.454 81.802-111.93 123.75-160.77z",
    fill: "none",
    stroke: "url(#h)",
    strokeWidth: 13.524
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfPreview);
export default __webpack_public_path__ + "static/media/pdf_preview.09b18012.svg";
export { ForwardRef as ReactComponent };